/**
 * External URLs
 * Centralized location for all external links
 */

const DOCS_BASE = 'https://waap.docs.link11.com';

// Documentation URLs
export const DOCS_URL = DOCS_BASE;
export const AI_MANAGEMENT_DOCS_URL = `${DOCS_BASE}/console-walkthrough/analytics/ai-management`;
export const QUERY_FILTER_DOCS_URL = `${DOCS_BASE}/reference-information/query-filter-syntax-and-best-practices`;
